import React from 'react';
import 'core-js';
import styles from './index.css';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng/errorBoundary';
import Loadable from 'react-loadable';

const LoadaMyVideo = Loadable({
    loader: () => import('@ifeng/ui_pc_video').then(({ MyVideo }) => MyVideo),
    loading() {
        return <div />;
    },
});

class PicMask extends React.PureComponent {
    state = {
        prevHover: false,
        nextHover: false,
    };
    handleMouseMove = e => {
        const l = (document.body.clientWidth * 1) / 3;

        if (e.pageX < l && this.state.prevHover === false) {
            // 左边1/3按钮显示
            this.setState({ prevHover: true, nextHover: false });
        }
        if (e.pageX > l && this.state.nextHover === false) {
            // 右边2/3按钮显示
            this.setState({ prevHover: false, nextHover: true });
        }
    };

    componentDidMount(e) {
        document.getElementsByTagName('body')[0].style.overflowY = 'hidden';
    }

    componentWillUnmount(e) {
        document.getElementsByTagName('body')[0].style.overflowY = 'auto';
    }

    /**
     * 渲染组件
     */
    render() {
        const { prevHover, nextHover } = this.state;
        const { picMaskData, handlePicPrev, handlePicNext, handleBigClose, handleVideoPlay } = this.props;
        const { slideData, current, videoPlay, maskH, total, sH } = picMaskData;

        // console.log('MaskH__', maskH);
        // console.log('sH__', sH);
        const playermsg = {
            width: '100%',
            height: maskH,
            isAuth: 'auth',
            autoPlay: true,
        };

        // 当前展示对象
        const item = slideData[current];
        const type = item.type;
        // pic
        const picItem = <img src={item.url || item.posterUrl} style={{ height: maskH }} />;
        // video
        const videoItem = videoPlay ? (
            <LoadaMyVideo videoConfig={{ guid: item.guid }} playermsg={playermsg} />
        ) : (
            <div>
                <img style={{ height: 'auto' }} src={item.url || item.posterUrl} />
                <div className={styles.video_btn} onClick={handleVideoPlay} />
            </div>
        );

        return (
            <div className={styles.mask} onMouseMove={this.handleMouseMove} style={{ height: sH }}>
                <div className={styles.bgchange} style={{ height: sH }}>
                    <div className={styles.bigClos} onClick={handleBigClose} />
                    <div className={styles.bigpic} style={{ height: sH }}>
                        <div className={styles.swiper_container}>
                            <table className={styles.swiper_wrapper}>
                                <tbody>
                                    <tr>
                                        <td className={styles.swiper_slide} style={{ height: sH }}>
                                            {type === 'video' ? videoItem : picItem}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <a className={prevHover ? styles.picPrev : styles.hid} onClick={handlePicPrev} />
                    <a
                        className={nextHover ? styles.picNext : styles.hid}
                        data-type={current}
                        onClick={handlePicNext}
                    />
                    <div className={styles.mouseMask} />
                    {videoPlay ? (
                        ''
                    ) : (
                        <div className={styles.picTxtBox}>
                            <div className={styles.picTxt}>
                                <div className={styles.picPage}>
                                    <span className={styles.DB_current}>{current + 1}</span>
                                    <span className={styles.line02}>/</span>
                                    <span className={styles.DB_total}>{total}</span>
                                </div>
                                <ul>
                                    <li>
                                        <h2 className={styles.photoDesc} style={{ display: 'none' }}>
                                            {item.title}
                                        </h2>
                                        <p className={styles.photoDesc}>{item.description || item.title}</p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        );
    }
}
/**
 * 定义组件属性类型
 * */
PicMask.propTypes = {
    picMaskData: PropTypes.object,
    handlePicPrev: PropTypes.func,
    handlePicNext: PropTypes.func,
    handleBigClose: PropTypes.func,
    handleVideoPlay: PropTypes.func,
};

/**
 * 定义组件默认属性
 * */
PicMask.defaultProps = {};

export { PicMask };
export default errorBoundary(PicMask);
